// extracted by mini-css-extract-plugin
module.exports = {"iframe":"style__iframe___2XyzO"};